import { MedplumClient } from "@medplum/core";

export const fetchGoalsAndTasks=async(medplum:MedplumClient,payload:any)=>{
    try{
        const res = await medplum.executeBot(
            {
              system: 'https://api-stage.healthconnect.systems/bots',
              value: 'assign-care-plan-using-ai'
            }
            , payload);
            return res;


    }catch(error){
        console.error("Unexpected error:", error);

    }

}

export const fetchResource=async(resourceType:any,medplum:MedplumClient,ids:any)=>{

const query =`_count=20&_id=${ids}&_offset=0&_sort=-_lastUpdated&_total=accurate`
try{
    const response = medplum.searchResources(resourceType,query);
return response
}catch(error){
    console.error(error)
}
}